import React, { memo } from 'react';
import { Route, Switch, useRouteMatch, Redirect } from 'react-router-dom';

import { LoadLayoutData, NotFoundPage } from '.';
import { FALLBACK_PATH } from 'services/constants';

const AppRouter = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={`${path}:bu/:lang`}>
        <LoadLayoutData />
      </Route>
      <Route exact path={`${path}:bu/:section/:lang`}>
        <LoadLayoutData />
      </Route>
      <Redirect to={FALLBACK_PATH} />
      <Route path="/">
        <NotFoundPage />
      </Route>
    </Switch>
  );
};

export default memo(AppRouter);
